import { ErrorLogComponent } from '@cian/error-log-component';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Provider } from 'react-redux';

import styles from './App.css';
import { FixedComponentsStore } from './components/common/fixed_component/fixed_components_store';
import { MobileVillageCardPage } from './components/mobile/mobile_village_card_page';
import { VillageCardPageContainer } from './components/village_card/container';
import { TReduxStore } from './store';
import { IApplicationContext } from './types/applicationContext';
import { ApplicationContext } from './utils/applicationContext';

export interface IContext extends IApplicationContext {
  fixedComponentsStore?: FixedComponentsStore;
}

export interface IAppProps {
  context: IContext;
  reduxStore: TReduxStore;
}

export class App extends React.Component<IAppProps> {
  // @ts-ignore
  public context: IContext;

  public static childContextTypes = {
    config: PropTypes.object,
    httpApi: PropTypes.object,
    logger: PropTypes.object,
    reactErrorLogger: PropTypes.object,
    fixedComponentsStore: PropTypes.object,
    telemetry: PropTypes.object,
  };

  public getChildContext(): IContext {
    const { config, httpApi, logger, telemetry } = this.props.context;

    return {
      config,
      httpApi,
      logger,
      fixedComponentsStore: new FixedComponentsStore(),
      telemetry,
    };
  }

  public render() {
    const { reduxStore, context } = this.props;
    const {
      mobile: { isMobileVersion },
    } = reduxStore.getState();

    return (
      <ErrorLogComponent logger={context.logger}>
        <ApplicationContext.Provider value={context}>
          <div className={styles['index']}>
            <Provider store={reduxStore}>
              {isMobileVersion ? <MobileVillageCardPage /> : <VillageCardPageContainer />}
            </Provider>
          </div>
        </ApplicationContext.Provider>
      </ErrorLogComponent>
    );
  }
}
